import { ReactNode } from 'react';
import styles from './filterSection.module.scss';

interface Props {
  children: ReactNode;
  label: string;
  htmlFor: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  styling?: 'desktop' | 'modal';
  onClick?: () => void;
}

const FilterSection = ({
  children,
  label,
  htmlFor,
  iconLeft,
  iconRight,
  styling = 'desktop',
  onClick
}: Props) => {
  return (
    <div
      data-testid={`PT-filterSection-${htmlFor}-filterSectionDiv`}
      className={styles[styling]}
      onClick={onClick}
      role={styling === 'modal' ? 'button' : 'cell'}
    >
      {iconLeft && <span className={styles.iconLeft}>{iconLeft}</span>}

      <div className={styles.content}>
        <label htmlFor={htmlFor}>{label}</label>
        {children}
      </div>
      {iconRight && <span className={styles.iconRight}>{iconRight}</span>}
    </div>
  );
};

export default FilterSection;
